"use client";
import React from "react";
import Screen from "../../components/Screen";
import ProfileHeaderSection from "../../components/ProfileHeaderSection";
import HeaderDescription from "../../components/HeaderDescription";
import HeaderBox from "../../components/Box/HeaderBox";
import { FowardButton } from "../../components/forms/DashboardButton";
import { useNavigate } from "react-router-dom";

const EmployeeManual = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/how-to-work/benefit");
  };
  const handleReadMore = () => {
    window.open(
      "https://drive.google.com/file/d/1-ue_5t3CXqPqvYzj1LJ5xrOvQuHWL-df/view?usp=drive_link",
      "_blank"
    );
  };

  return (
    <div className="bg-white w-full">
      <Screen>
        <ProfileHeaderSection />
        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Our Team"}
          subsubtext={"Employee Manual"}
        />
        <p className={` text-4xl text-lightDark my-4`}>Employee Manual</p>
        <div className="">
          <HeaderBox text="Revolutionizing African healthcare through technology" />
        </div>
        <div
          className={` text-black ml-2 mt-4 text-basetext leading-10 text-left`}
        >
          The LifeBank Creed serves as the core guide for our operations and
          expectations. It outlines the principles for how we manage our people
          and conduct ourselves. As LifeBank grows, updates to the Creed may be
          necessary, and employees will be informed of any changes. While the
          Creed provides broad guidelines, not all scenarios may be covered, and
          such situations will be addressed individually. For any questions or
          concerns, please consult your Team Lead or the Director of People for
          further clarification.
        </div>
        <p
          className="cursor-pointer mt-4 ml-2 text-lightRed"
          onClick={handleReadMore}
        >
          Access the Employee Manual here
        </p>

        <div className="my-4 flex justify-end absolute bottom-2 right-3">
          <FowardButton
            text={"Next"}
            onClick={handleNext}
            subText={"Employee Benefits"}
          />
        </div>
      </Screen>
    </div>
  );
};

export default EmployeeManual;
